export { PaymentMethods } from './payment-methods.component';
